@for (item of items(); track item.key()) {
  <div class="accordion-item ps-xsmall-y">
    <button
      (click)="toggleOpen(item)"
      class="accordion-item-label align-left flex--nowrap fill flex flex--space-between font-body-1 medium-type"
      [id]="'accordion-btn-' + item.key()"
      [attr.aria-controls]="'accordion-region-' + item.key()"
    >
      <span class="ms-medium-r">
        {{ item.label() }}
      </span>
      <fcom-icon
        [class.rotate-active]="isOpen(item)"
        class="rotate flex--shrink0"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      />
    </button>
    <fcom-expand
      [open]="isOpen(item)"
      [ariaId]="'accordion-region-' + item.key()"
      [ariaLabelledBy]="'accordion-btn-' + item.key()"
      class="block ps-xxsmall-t"
    >
      <ng-container [ngTemplateOutlet]="item.content" />
    </fcom-expand>
  </div>
  @if (!$last) {
    <hr class="ms-xsmall-y" />
  }
}
